module.exports = __webpack_public_path__ + "img/4.902be647.jpg";